module.exports = __webpack_public_path__ + "img/C08TechIndrasProsperity_ua.dcccf991.webp";